import React from 'react';
import dayjs from 'dayjs';

export default function DiscountBadge({ product }) {
    if (!product) return null;

    const regular = Number(product?.price);
    const sale = Number(product?.discountPrice);
    const sale2 = Number(product?.discountPrice2);

    // Must be valid numbers
    if (!regular || (!sale && !sale2) || (sale && sale >= regular) || (sale2 && sale2 >= regular)) return null;

    // Read date ranges
    const fromDate = product?.fromDate;
    const toDate = product?.toDate;
    const fromDate2 = product?.fromDate2 ?? fromDate;
    const toDate2 = product?.toDate2 ?? toDate;

    const now = dayjs();
    const start = fromDate ? dayjs(fromDate).startOf("day") : null;
    const end = toDate ? dayjs(toDate).endOf("day") : null;
    const start2 = fromDate2 ? dayjs(fromDate2).startOf("day") : null;
    const end2 = toDate2 ? dayjs(toDate2).endOf("day") : null;

    // Helper to check if discount is active
    const isActive = (start, end) => {
        if (!start && !end) return true;
        if (start && end) return (now.isAfter(start) && now.isBefore(end)) || now.isSame(start) || now.isSame(end);
        if (start && !end) return now.isAfter(start) || now.isSame(start);
        if (!start && end) return now.isBefore(end) || now.isSame(end);
        return false;
    };

    const isSaleActive = sale > 0 && isActive(start, end);
    const isSale2Active = sale2 > 0 && isActive(start2, end2);

    // If no active discounts, return null
    if (!isSaleActive && !isSale2Active) return null;

    // --- MAIN BADGE (price → discountPrice ONLY) ---
    let mainPercentage = null;
    if (isSaleActive && sale > 0 && sale < regular) {
        mainPercentage = Math.round(((regular - sale) / regular) * 100);
    }

    // If no main discount, show nothing
    if (mainPercentage === null) return null;

    // --- EXTRA BADGE (discountPrice → discountPrice2) ---
    let extraPercentage = null;
    if (isSale2Active && isSaleActive && sale2 > 0 && sale2 < sale && sale < regular) {
        extraPercentage = Math.round(((sale - sale2) / sale) * 100);
    }

    return (
        <>
            {/* Main discount badge - original design */}
            <span
                className="discount-badge"
                aria-label={`Discount ${mainPercentage}%`}
            >
                -{mainPercentage}%
            </span>
            {/* Extra discount badge - positioned below the main badge */}
            {extraPercentage !== null && extraPercentage > 0 && (
                <span
                    className="discount-badge extra-discount-badge"
                    aria-label={`Extra discount ${extraPercentage}%`}
                >
                    EXTRA -{extraPercentage}%
                </span>
            )}
        </>
    );
}
